import { useQuery, UseQueryResult } from 'react-query';
import { AppointmentRetrieve } from 'types';
import { client } from 'utils/api-client';

function useAppointment(appointmentId: string | undefined): UseQueryResult<{ data: AppointmentRetrieve }> {
  return useQuery(['appointments', appointmentId], () => client.get(`appointments/${appointmentId}/`), {
    enabled: !!appointmentId,
  });
}

export default useAppointment;
